export class StateModel {
    id: number;
    name: string;
}